import { User } from '@arpeggi/shared'
import { Box, Button } from '@arpeggi/ui'
import { FC, ReactNode, Suspense, useState } from 'react'
import CenteredLoadingAnimation from '../../../__legacy__/components/core/CenteredLoadingAnimation'
import { Flex } from '../../../__legacy__/components/core/Flex'
import { Modal, ModalComponents } from '../../../__legacy__/components/core/Modal'
import SuspenseImage from '../../../__legacy__/components/core/SuspenseImage'
import Text from '../../../__legacy__/components/core/Text/Text'

const RemixCompetitionStep: FC<{ step: number; title: string; description: ReactNode }> = ({
  step,
  title,
  description
}) => {
  return (
    <Flex css={{ gap: '16px' }}>
      <Box
        css={{
          backgroundColor: '$black',
          height: '32px',
          width: '32px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '$white',
          fontWeight: '600'
        }}
      >
        {step}
      </Box>
      <Flex css={{ flex: 1, gap: '8px', flexDirection: 'column' }}>
        <Text size="20">{title}</Text>
        <Text>{description}</Text>
      </Flex>
    </Flex>
  )
}

interface Props {
  user: User
  handleDownload: () => void
}

export const RemixCompetitionModal: FC<Props> = ({ user, handleDownload }) => {
  const [open, setOpen] = useState(true)

  let bgUrl = '/static/images/orrin_comp.png'

  // TODO find a better way to manage, maybe internal dash
  const orrinWalletAddress = '0x7056A5Da7D269B31Eb2E54E5579e41ef283d7D2C'
  if (user.walletAddress !== orrinWalletAddress) {
    bgUrl = '/static/images/reo_cragun_comp.png'
  }

  return (
    <Modal open={open} onOpenChange={setOpen} contentCss={{ width: '465px', padding: '32px' }}>
      <Suspense
        fallback={
          <Flex css={{ minHeight: '400px', alignItems: 'center', justifyContent: 'center' }}>
            <CenteredLoadingAnimation />
          </Flex>
        }
      >
        <SuspenseImage
          src={bgUrl}
          alt={user.displayName}
          css={{
            objectFit: 'cover',
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            zIndex: -1
          }}
        />
        <ModalComponents.HeaderContainer
          css={{ borderBottom: 'none', paddingTop: '16px', paddingBottom: '16px' }}
        >
          <ModalComponents.Title>#OnlyUp Remix Competition</ModalComponents.Title>
        </ModalComponents.HeaderContainer>
        <ModalComponents.Container>
          <Flex css={{ gap: '32px', flexDirection: 'column' }}>
            <RemixCompetitionStep
              step={1}
              title={`Download Orrin’s stems`}
              description={
                <>
                  Download the vocal stems to use to remix in your own DAW, or remix right in
                  Arpeggi Studio.{' '}
                  <a
                    style={{ color: '#4F7EDA' }}
                    target="_blank"
                    href={'https://docs.arpeggi.io/faq/making-music-with-arpeggi'}
                  >
                    Learn more
                  </a>
                </>
              }
            />
            <RemixCompetitionStep
              step={2}
              title="Upload your remix"
              description={
                <>
                  Upload your remix on Orrin’s song detail page by November 18, 2022.{' '}
                  <a
                    style={{ color: '#4F7EDA' }}
                    target="_blank"
                    href={
                      'https://docs.google.com/document/d/1oSTbG3jPIqUE3zn9JhVWJFhWnZavISPJ/edit'
                    }
                  >
                    Full terms
                  </a>
                </>
              }
            />
          </Flex>
        </ModalComponents.Container>
        <ModalComponents.FooterContainer css={{ borderTop: 'none', gap: '8px', paddingBottom: 0 }}>
          <Button css={{ flex: 1 }} variant="secondary" onClick={() => setOpen(false)}>
            View sample pack
          </Button>
          <Button
            css={{ flex: 1 }}
            onClick={() => {
              setOpen(false)
              handleDownload()
            }}
          >
            Download samples
          </Button>
        </ModalComponents.FooterContainer>
      </Suspense>
    </Modal>
  )
}
